import { Spin, Typography } from 'antd';
import LayoutPage from '../../layouts/Main';
import './dashboard.css';

const { Text } = Typography;

const DashboardSkeleton = () => (
  <LayoutPage>
    <div className="dashboard-main-container">
      <div className="dashboard-skeleton">
        <Spin size="large" />
        <Text>Cargando dashboard...</Text>
      </div>
    </div>
  </LayoutPage>
);

export default DashboardSkeleton;